module.exports = __webpack_public_path__ + "static/img/notOpen.f1ed2c6d.png";